import { Button, Stack, Typography } from '@mui/material';
import React from 'react';

interface PreviewControlsProps {
 url: string;
 onRemove: () => void;
 campaignId?: number;
 creativeId?: number;
}

function PreviewControls({ url, onRemove, campaignId, creativeId }: PreviewControlsProps) {
  let previewStudioHref: string | null = null;
  if (campaignId && creativeId) {
    previewStudioHref = `/preview?campaign_id=${campaignId}&creative_id=${creativeId}`;
  } else if (creativeId) {
    previewStudioHref = `/preview?creative_id=${creativeId}`;
  }

 return (
  <Stack direction="row" justifyContent="space-between" py={1}>
    <Typography variant="caption" component="div" sx={{ display: 'flex', alignItems: 'center' }}>
       <Button
        size="small"
         onClick={onRemove}
         disableRipple
         type="button"
         variant="text"
         sx={{ padding: 0, "&:hover": { backgroundColor: "transparent" } }}
       >
         Remove
       </Button>
       <Button
        size="small"
         component="a"
         href={url}
         target="_blank"
         rel="noreferrer"
         disableRipple
         variant="text"
         sx={{ padding: 0, ml: 2, "&:hover": { backgroundColor: "transparent" } }}
       >
         View In Original Size
       </Button>
        {previewStudioHref && (
          <Button
            size="small"
            disableRipple
            variant="text"
            sx={{ padding: 0, ml: 2, "&:hover": { backgroundColor: "transparent" } }}
            onClick={() => {
              window.open(previewStudioHref, '_blank', 'noopener,noreferrer');
            }}
          >
            Open in Preview Studio
          </Button>
        )}
     </Typography>
   </Stack>
 );
}

export default PreviewControls;
